<template>
  <ConfirmationModal
    :title="$t('CALL_FLOW_IN_USE_TITLE')"
    :show-confirm-button="true"
    :show-cancel-button="true"
    :cancel-button-text="$t('CANCEL')"
    :confirm-action-text="saveDraft? $t('CLONE_AND_SAVE'): $t('SAVE_AND_PUBLISH')"
    @close="closeModal"
    @confirm="onConfirm"
  >
    <div>
      <p
        v-t="saveDraft? 'SAVE_FLOW_DRAFT_MODAL_ASSOCIATION_TEXT': 'SAVE_FLOW_MODAL_ASSOCIATION_TEXT'"
        class="m-b-10"
      />
      <div class="well well-sm m-b-10">
        <div class="form-horizontal">
          <div class="row">
            <label class="col-md-3 control-label">
              <strong>Campaigns</strong>
            </label>
              
            <div class="col-md-8">
              <ul class="list-unstyled form-control-static list-text-overflow">
                <li
                  v-for="(campaign, index) in callFlowTreeReferences.campaigns"
                  :key="index"
                >
                  <a
                    :href="`#/dashboard/campaign/${campaign.campaignId}`"
                    target="_blank"
                  >
                    <span
                      class="display-text"
                      :title="campaign.campaignName"
                    >
                      {{ campaign.campaignName }}
                      <i
                        v-if="campaign.campaignNoRoutes"
                        v-tooltip.right.hover="$t('NO_ROUTE_SETUP_WARNING')"
                        class="fa fa-exclamation-circle text-danger f-s-14 m-l-5"
                        aria-hidden="true"
                      />
                    </span>
                    <i
                      v-tooltip.right.hover="$t('VIEW_CAMPAIGN_TEXT')"
                      tooltip-placement="right" 
                      class="fa fa-external-link m-l-5"
                      aria-hidden="true"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ConfirmationModal>
</template>

<script>
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import messages from '../../locales';
import sharedMessages from '@/core/locales';

export default {
  name: 'CallFlowReferencesModal',
  components: {
    ConfirmationModal
  },
  props:{
    callFlowTreeReferences: {
      type: Object,
      default() {
        return {};
      }
    },
    saveDraft: {
      type: Boolean,
      default: false,
    }
  },
  methods:{
    closeModal() {
      this.$emit('closeModal');
    },
    onConfirm() {
      if (this.saveDraft) {
        this.$emit('cloneAndSave');
      } else {
        this.$emit('save');
      }
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>